import { Alert } from "@mui/material";
export default function UploadStatusAlert({ status }) {
  if (!status) return null;
  return <Alert severity={status.type}>{status.message}</Alert>;
}